import { DOMAttributes, PropsWithChildren } from 'react'

export type DeleteButtonProps = PropsWithChildren<{
  onClick?: DOMAttributes<HTMLDivElement>['onClick']
}>
export function DeleteButton(props: DeleteButtonProps) {
  return (
    <div
      className="flex items-center justify-center h-12 cursor-pointer border-2 border-option rounded-lg text-option mt-8"
      onClick={props.onClick}
    >
      <a className="text-lg font-medium flex items-center">{props.children}</a>
    </div>
  )
}
